import React from 'react'
import { Blueprint } from '@leverege/api-redux'
import { connect } from 'react-redux'
import { BlueprintTranslationScreen as BPTranslationScreen } from '@leverege/api-ui-i18n-management'

import { BlueprintActions } from '~/actions'

class BlueprintTranslationScreen extends React.Component {
  constructor( props ) {
    super( props )
    const { match : { params : { projectId, blueprintId } } } = props

    this.delegate = new Blueprint( projectId, blueprintId )
  }

  componentDidMount() {
    const { dispatch, match } = this.props
    dispatch( BlueprintActions.getBlueprint( match.params.projectId, match.params.blueprintId ) )
  }

  render() {
    const { blueprint } = this.props
    return (
      <BPTranslationScreen
        delegate={this.delegate}
        blueprint={blueprint} />
    )
  }
}

export default connect( ( state ) => {
  return {
    blueprint : state.blueprint
  }
} )( BlueprintTranslationScreen )
